import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  QueryReturnType,
  mutatePatchFn,
} from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  page: string;
  limit: string;
  search: string;
  /** pending | resolved — omit for all */
  status?: string;
}

export const useGetHostRequests = ({
  page,
  limit,
  search,
  status,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [
      ENDPOINTS.GET_HOST_REQUESTS,
      { page: page, limit: limit, search: search, status: status || undefined },
    ],
    {
      retry: false, // Don't retry on failure
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};

/** PATCH admin/host-requests/:requestId — mark resolved, or reopen (status: "pending"). */
export const useResolveHostRequest = () => {
  const qc = useQueryClient();
  return useMutation(
    ({ id, status }: { id: string; status: "pending" | "resolved" }) =>
      mutatePatchFn(
        ENDPOINTS.RESOLVE_HOST_REQUEST.replace(":requestId", id),
        { status }
      ),
    {
      onSuccess: () => {
        qc.invalidateQueries([ENDPOINTS.GET_HOST_REQUESTS]);
      },
    }
  );
};
